import styled from "styled-components";
import { Settings } from "@styled-icons/ionicons-outline";
import { ArrowNarrowLeft } from "@styled-icons/heroicons-outline";
import { Plus } from "@styled-icons/boxicons-regular";
import { Trash } from "@styled-icons/boxicons-regular";
import { Loading } from "styles/styled-components";
import { Colors, fonts } from "styles";

export {
  PageContainer,
  PageHeader,
  PageContent,
  Button,
  ButtonMini,
  BoxContainer,
  FormFooter,
  FormRow,
  Loading,
} from "styles/styled-components";

export const IconSetting = styled(Settings).attrs({ size: 24 })``;

export const LoadingPage = styled(Loading)`
  margin-left: 16px;
`;

export const IconArrowLeft = styled(ArrowNarrowLeft).attrs({ size: 20 })`
  margin-right: 8px;
`;

export const WeekDays = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 16px;
`;

export const DeliveryTitle = styled.h1`
  margin-top: 16px;
`;

export const HeaderButtons = styled.div`
  display: flex;
  button{
    margin-right: 10px;
  }
`;

export const Separator = styled.div`
  display: flex;
  margin: 16px;
`;

export const NotificationEmailsContainer = styled.div`
  margin-top: 16px;
`;

export const NotificationEmailsTitle = styled.h3`
  font-family: ${fonts.GilroySemiBold};
  font-size: 14px;
  color: ${Colors.Gray50};
  margin-bottom: 16px;
`;

export const RegisteredEmailsList = styled.ul`
  margin-bottom: 12px;
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const RegisteredEmailItem = styled.li`
  padding: 6px 10px;
  border-radius: 999px;
  background-color: ${Colors.Gray10};
  color: ${Colors.Gray100};
  font-family: ${fonts.OpenSans};
  font-size: 12px;
`;

export const EmailInputRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;

  > div {
    flex: 1;
  }
`;

export const IconPlus = styled(Plus).attrs({ size: 20 })`
  color: ${Colors.Gray50};
`;

export const IconTrash = styled(Trash).attrs({ size: 20 })`
  color: ${Colors.Red};
`;

export const ButtonAddEmail = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: transparent;
  border: 1px solid ${Colors.Gray30};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${Colors.Gray10};
    border-color: ${Colors.Gray40};
  }
`;

export const ButtonRemoveEmail = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: transparent;
  border: 1px solid ${Colors.Red};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 24px;

  &:hover {
    background: ${Colors.Red}10;
  }
`;

export const EmailInputWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const EmailInputLabel = styled.label`
  font-family: ${fonts.GilroySemiBold};
  font-size: 12px;
  color: ${Colors.Gray50};
  margin-bottom: 8px;
`;

export const EmailInput = styled.input`
  font-family: ${fonts.OpenSans};
  font-size: 14px;
  color: ${Colors.Gray100};
  background-color: #fff;
  padding: 16px;
  border: 1px solid #c9c9c9;
  border-radius: 4px;
  max-height: 50px;
  width: 100%;

  &:focus {
    outline: none;
    border-color: ${Colors.Gray50};
  }
`;

export const ErrorMessage = styled.span`
  display: block;
  font-family: ${fonts.GilroySemiBold};
  font-size: 14px;
  color: ${Colors.Red};
  margin-bottom: 12px;
`;